import { makeStyles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const title1ClassNames = {
    root: 'fui-Title1'
};
/**
 * Styles for the root slot
 */ export const useTitle1Styles = makeStyles({
    root: typographyStyles.title1
});
